import { makeStyles } from '~/theme';

export const useStyles = makeStyles()(() => ({
  checkbox: {
    padding: '6px',
    marginRight: '6px',
  },
}));
